import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { AssetType } from '../../../../asset-management/_shared/enums/asset-type.enum';
import { getAssetTypeLabel } from '../../../../asset-management/_shared/helpers/asset-type-filter.helper';

interface AssetTypeOption {
  value: AssetType;
  label: string;
}

@Component({
  selector: 'app-asset-type-filter',
  standalone: true,
  imports: [CommonModule, NgbDropdownModule],
  templateUrl: './asset-type-filter.component.html',
  styleUrl: './asset-type-filter.component.scss'
})
export class AssetTypeFilterComponent {
  @Output() typeChanged = new EventEmitter<AssetType | null>();

  assetTypes: AssetTypeOption[] = Object.values(AssetType)
    .filter((v): v is AssetType => typeof v === 'number')
    .map(v => ({ value: v, label: getAssetTypeLabel(v) }));

  selectedType: AssetTypeOption | null = null;

  get label(): string {
    return this.selectedType?.label ?? 'Asset Type';
  }

  get isPlaceholder(): boolean {
    return this.selectedType === null;
  }

  onSelect(type: AssetTypeOption | null): void {
    this.selectedType = type;
    this.typeChanged.emit(type?.value ?? null);
  }
}